export default __webpack_public_path__ + "static/media/025-flag.4e6f3f9c.png";